var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderStripes'),_c('LogoContainer',{attrs:{"tel":_vm.getData.tel,"email":_vm.getData.email}}),_c('Navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }